import { render } from "./SaleInvoiceDetailsView.vue?vue&type=template&id=6ed22714&scoped=true"
import script from "./SaleInvoiceDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleInvoiceDetailsView.vue?vue&type=script&lang=js"

import "./SaleInvoiceDetailsView.vue?vue&type=style&index=0&id=6ed22714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed22714"]])

export default __exports__